import { LitElement, html, css } from 'lit';

class SnapshotSaveDialog extends LitElement {
    static styles = css`
        :host {
            display: none;
        }
        :host([visible]) {
            display: block;
        }
        .overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,0.6);
            z-index: 2100;
        }
        .dialog {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: white;
            padding: 20px;
            border-radius: 8px;
            z-index: 2101;
            width: 400px;
        }
        .dialog h3 {
            margin-top: 0;
        }
        .form-field {
            margin-bottom: 15px;
        }
        .form-field label {
            display: block;
            margin-bottom: 5px;
        }
        .form-field input, .form-field textarea {
            width: 100%;
            padding: 8px;
            box-sizing: border-box;
            border: 1px solid #ccc;
            border-radius: 4px;
        }
        .actions {
            text-align: right;
        }
        .actions button {
            margin-left: 10px;
        }
        .snapshot-button {
            background-color: rgb(0, 123, 255);
            border-radius: 30px;
            border: none;
            color: white;
            text-align: center;
            text-decoration: none;
            display: inline-block;
            font-size: 16px;
            transition-duration: 0.4s;
            padding: 6px 15px;
        }
        .snapshot-button.gray {
            background-color: rgba(163, 163, 163, 1);
        }
    `;

    static properties = {
        visible: { type: Boolean, reflect: true }
    };

    constructor() {
        super();
        this.visible = false;
    }

    show() {
        this.visible = true;
    }

    hide() {
        this.visible = false;
    }

    _handleSave() {
        const nameInput = this.shadowRoot.querySelector('#snapshot-name');
        const descInput = this.shadowRoot.querySelector('#snapshot-description');
        
        if (!nameInput.value.trim()) {
            alert('スナップショット名は必須です。');
            return;
        }
        
        this.dispatchEvent(new CustomEvent('save-snapshot', {
            detail: {
                name: nameInput.value,
                description: descInput.value,
            },
            bubbles: true,
            composed: true
        }));
        
        nameInput.value = '';
        descInput.value = '';
        this.hide();
    }
    
    _handleCancel() {
        this.hide();
    }

    render() {
        return html`
            <div class="overlay" @click=${this.hide}>
                <div class="dialog" @click=${e => e.stopPropagation()}>
                    <h3>スナップショットを保存</h3>
                    <div class="form-field">
                        <label for="snapshot-name">名前 (必須)</label>
                        <input type="text" id="snapshot-name" placeholder="例: ヘッダーデザイン変更後">
                    </div>
                    <div class="form-field">
                        <label for="snapshot-description">説明 (任意)</label>
                        <textarea id="snapshot-description" rows="3" placeholder="変更内容のメモなど"></textarea>
                    </div>
                    <div class="actions">
                        <button class="snapshot-button gray" @click=${this._handleCancel}>キャンセル</button>
                        <button class="snapshot-button" @click=${this._handleSave}>保存</button>
                    </div>
                </div>
            </div>
        `;
    }
}

customElements.define('snapshot-save-dialog', SnapshotSaveDialog);